import Vue from 'vue'
import App from './App.vue'
import router from './router'




import axios from "axios";

import Loading from "vue-loading-overlay";
Vue.use(Loading);

import "vue-loading-overlay/dist/vue-loading.css";

import M from "materialize-css";


Vue.config.productionTip = false






/*
  Convert dates to SIREN format
*/
Date.prototype.formatSGTM = function () {
  let year = this.getFullYear();
  let month = ("0" + (this.getMonth() + 1)).slice(-2);
  let day = ("0" + this.getDate()).slice(-2);

  return `${year}-${month}-${day}`;
}



/*
  Add overlay in Axios AJAX requests
*/
var loader;

axios.interceptors.request.use(cfg => {
  if (!loader) loader = Vue.$loading.show();
  return cfg;
});

axios.interceptors.response.use(resp => {
  if (loader) loader.hide();
  loader = null;
  return resp;
}, function (error) {
  if (loader) loader.hide();
  loader = null;
  M.toast({html: "Une erreur s'est produite avec le serveur !"});
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  console.log(error.config);

  return Promise.reject(error);
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

